module.exports = __webpack_public_path__ + "static/img/08.8796269.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/08.jpg
// module id = 3O/T
// module chunks = 1